import React, { memo, useCallback, useRef, useEffect } from 'react'
import PropTypes from 'prop-types'
import { AnimatePresence } from 'framer-motion'
import CustomScroller from 'react-custom-scroller'
import { useSetRecoilState, useRecoilState } from 'recoil'

import { 
  selectedMember as selectedMemberState, 
  showMember as showMemberState,
  currentSection as currentSectionState 
} from '../../store/uiStore'

import MemberAccent from './MemberAccent'
import MemberSocial from './MemberSocial'
import BackButton from '../Navigation/BackButton'

import {
  TeamModalContainer,
  TeamModalWrapper,
  TeamModalName,
  TeamModalImage,
  TeamModalSubtitle,
  TeamModalDownload,
  TeamModalBio,
} from '../../styles/teamStyles'

const TeamModal = ({ member, isActive }) => {

  const setCurrentSection = useSetRecoilState(currentSectionState)
  const [showMember, setShowMember] = useRecoilState(showMemberState)
  const setSelectedMember = useSetRecoilState(selectedMemberState)

  const memberScroller = useRef(null)

  const handleBackToTeam = useCallback(() => {
    setSelectedMember((last) => -1)
    setShowMember((last) => false)
    setCurrentSection((last) => 'equipo')
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [])

  useEffect(() => {
    if ( isActive ) {
      memberScroller.current.scrollTop = 0
    }
  }, [isActive])
  
  return (
    <AnimatePresence exitBeforeEnter>
      {isActive && (
        <TeamModalContainer
          initial={{
            opacity: 0,
          }}
          animate={{
            opacity: 1,
          }}
          transition={{
            duration: 1,
            ease: 'easeOut',
          }}
          exit={{
            opacity: 0,
            transition: {
              delay: 1.5,
              duration: 1,
            }
          }}>
          <MemberAccent isVisible={showMember} />
          <BackButton type='backToTeam' label='Volver a Equipo' handle={handleBackToTeam} />
          <CustomScroller ref={memberScroller} className='Scroller' innerClassName='ScrollerContent'>
            <TeamModalWrapper
              initial={{
                opacity: 0,
                y: '-30%',
              }}
              exit={{
                opacity: 0,
                y: '-30%',
                transition: {
                  duration: 1,
                  delay: 0,
                }
              }}
              animate={{
                opacity: 1,
                y: 0,
              }}
              transition={{
                default: {
                  duration: 1,
                  ease: 'easeOut',
                  delay: 0.5,
                },
                opacity: {
                  duration: 1.5,
                  ease: 'linear',
                  delay: 0.5,
                },
              }}>
              <TeamModalImage><img src={member.image} alt={member.name} /></TeamModalImage>
              <TeamModalName>{member.name}</TeamModalName>
              <TeamModalSubtitle>{member.position}</TeamModalSubtitle>
              { member.resume && (
                <TeamModalDownload href={member.resume} target='_blank' rel='noopener noreferrer' download>Descargar CV</TeamModalDownload>
              )}
              <MemberSocial social={member.social} />
              <TeamModalBio dangerouslySetInnerHTML={{ __html: member.bio}} />
            </TeamModalWrapper>
          </CustomScroller>
        </TeamModalContainer>
      )}
    </AnimatePresence>
  )
}

TeamModal.propTypes = {
  isActive: PropTypes.bool.isRequired,
  member: PropTypes.object.isRequired
}

export default memo(TeamModal)
